<nz-spin [nzSpinning]="loading$ | async">
  <form
    nz-form
    class="form"
    nzLayout="horizontal"
    [formGroup]="broadcastForm"
    (ngSubmit)="submitForm(false)">
    <div class="drawer-form-wrapper">
      <nz-form-item>
        <nz-form-label nzFor="broadcastTypeId" nzRequired
          >Broadcast Type</nz-form-label
        >
        <nz-form-control nzErrorTip="Please select a broadcast type">
          <nz-select
            nzSuffixIcon
            nzShowSearch
            nzAllowClear
            formControlName="broadcastTypeId"
            nzPlaceHolder="Select broadcast type"
            [nzDisabled]="drawerBroadcastParams.mode === 'VIEW'"
            [nzOptionOverflowSize]="7">
            <nz-option
              *ngFor="let type of broadcastTypes$ | async"
              [nzLabel]="type.value"
              [nzValue]="type.id">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="title" nzRequired>Title</nz-form-label>
        <nz-form-control nzErrorTip="Please enter a title">
          <input
            name="title"
            type="text"
            nz-input
            id="title"
            formControlName="title"
            placeholder="Enter title"
            [disabled]="drawerBroadcastParams.mode === 'VIEW'" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="message" nzRequired>Message</nz-form-label>
        <nz-form-control [nzErrorTip]="messageErrorTpl">
          <ng-container
            *ngIf="
              drawerBroadcastParams.mode === 'VIEW';
              else editMessageEditor
            ">
            <quill-editor
              class="w-100"
              formControlName="message"
              format="html"
              theme="snow"
              [placeholder]="''"
              [modules]="viewMessageEditorModules"
              [readOnly]="true"
              [sanitize]="true"
              [maxLength]="MAX_MESSAGE_LENGTH">
            </quill-editor>
          </ng-container>

          <ng-template #editMessageEditor>
            <quill-editor
              class="w-100"
              formControlName="message"
              format="html"
              theme="snow"
              [placeholder]="'Enter your message'"
              [modules]="messageEditorModules"
              [readOnly]="false"
              [sanitize]="true"
              [maxLength]="MAX_MESSAGE_LENGTH">
            </quill-editor>
          </ng-template>

          <ng-template #messageErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"
              >Please enter a message</ng-container
            >
            <ng-container *ngIf="control.hasError('maxlength')"
              >Message cannot exceed
              {{ MAX_MESSAGE_LENGTH }} characters</ng-container
            >
          </ng-template>
          <div
            *ngIf="drawerBroadcastParams.mode !== 'VIEW'"
            class="mt-3 remaining-text">
            {{ getMessageCharacterCount() }}
            of {{ MAX_MESSAGE_LENGTH }} characters used
          </div>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item *ngIf="isImportantUpdate">
        <nz-form-label nzFor="bannerColor">Banner Color</nz-form-label>
        <nz-form-control [nzErrorTip]="colorErrorTpl">
          <nz-color-picker
            id="bannerColor"
            formControlName="bannerColor"
            nzFormat="hex"
            nzShowText
            class="banner-color-picker"
            [nzDisabledAlpha]="true"
            (nzOnChange)="onBannerColorChange($event)"
            [nzDisabled]="drawerBroadcastParams.mode === 'VIEW'">
          </nz-color-picker>
          <ng-template #colorErrorTpl let-control>
            <ng-container *ngIf="control.hasError('pattern')">
              Please select a valid hex color (example: #1890ff)
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <ng-container *ngIf="!isGeneralBroadcastType">
        <nz-form-item>
          <nz-form-label nzFor="startDateTime" nzRequired
            >Start Date & Time</nz-form-label
          >
          <nz-form-control [nzErrorTip]="startDateErrorTpl">
            <nz-date-picker
              formControlName="startDateTime"
              [nzShowTime]="{
                nzFormat: 'hh:mm a',
                nzUse12Hours: true,
              }"
              [nzDisabled]="drawerBroadcastParams.mode === 'VIEW'"
              nzFormat="MM/dd/yyyy HH:mm: a"
              nzPlaceHolder="Select start date and time">
            </nz-date-picker>
            <ng-template #startDateErrorTpl let-control>
              <ng-container *ngIf="control.hasError('required')"
                >Please select start date and time</ng-container
              >
              <ng-container *ngIf="control.hasError('pastDate')"
                >Start date must be today or in the future</ng-container
              >
            </ng-template>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label nzFor="endDateTime" nzRequired
            >End Date & Time</nz-form-label
          >
          <nz-form-control [nzErrorTip]="endDateErrorTpl">
            <nz-date-picker
              formControlName="endDateTime"
              [nzShowTime]="{
                nzFormat: 'hh:mm a',
                nzUse12Hours: true,
              }"
              [nzDisabled]="drawerBroadcastParams.mode === 'VIEW'"
              nzFormat="MM/dd/yyyy HH:mm: a"
              nzPlaceHolder="Select end date and time">
            </nz-date-picker>
            <ng-template #endDateErrorTpl let-control>
              <ng-container *ngIf="control.hasError('required')"
                >Please select end date and time</ng-container
              >
            </ng-template>
          </nz-form-control>
        </nz-form-item>

        <div
          *ngIf="
            broadcastForm.hasError('endDateBeforeStart') &&
            broadcastForm.get('startDateTime')?.value &&
            broadcastForm.get('endDateTime')?.value
          "
          class="validation-error">
          End date must be greater than start date
        </div>
      </ng-container>

      <nz-form-item>
        <nz-form-label nzFor="targetOrganizations" nzRequired
          >Target Schools</nz-form-label
        >
        <nz-form-control nzErrorTip="Please select at least one school">
          <nz-select
            formControlName="targetOrganizations"
            nzSuffixIcon
            nzShowSearch
            nzAllowClear
            nzMode="multiple"
            nzShowArrow="true"
            nzPlaceHolder="Select Schools"
            [nzDisabled]="drawerBroadcastParams.mode === 'VIEW'"
            [nzLoading]="(organizationsLoading$ | async) === true"
            [nzOptionOverflowSize]="7"
            (nzOnSearch)="onOrganizationSearch($event)"
            [nzNotFoundContent]="notFoundTemplate"
            nzBackdrop="false">
            <nz-option
              *ngFor="let org of organizations$ | async; trackBy: trackByFn"
              [nzLabel]="org.value || ''"
              [nzValue]="org.id">
            </nz-option>
          </nz-select>

          <ng-template #notFoundTemplate>
            <div class="not-found-content">
              <ng-container
                *ngIf="organizationsLoading$ | async; else noDataTemplate">
                <div class="loading-container">
                  <nz-spin nzSimple></nz-spin>
                </div>
              </ng-container>
              <ng-template #noDataTemplate>
                <div class="no-data-container">
                  {{
                    noOrganizationsFound
                      ? 'No schools found'
                      : 'Type to search schools'
                  }}
                </div>
              </ng-template>
            </div>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div class="drawer-footer">
      <button type="button" nz-button nzType="default" (click)="cancel()">
        Cancel
      </button>
      <ng-container *ngIf="drawerBroadcastParams.mode === 'VIEW'">
        <button
          type="button"
          nz-button
          nzType="primary"
          (click)="switchToEditMode()">
          Edit
        </button>
      </ng-container>
      <ng-container *ngIf="drawerBroadcastParams.mode !== 'VIEW'">
        <div class="broadcast-cta-wrapper">
          <button
            nz-button
            type="button"
            nzType="default"
            [disabled]="broadcastForm.invalid"
            [nzLoading]="loading$ | async"
            (click)="saveAsDraft()">
            Save as Draft
          </button>
          <button
            type="submit"
            nz-button
            nzType="primary"
            [disabled]="broadcastForm.invalid"
            [nzLoading]="loading$ | async">
            {{
              drawerBroadcastParams.mode === 'CREATE'
                ? 'Add Broadcast'
                : 'Update Broadcast'
            }}
          </button>
        </div>
      </ng-container>
    </div>
  </form>
</nz-spin>
